<template>
  <div class="head-flex">
    <div class="logo">
      <img alt="" src="@/assets/images/logintitle.png">
    </div>
    <div class="head-nav">
      <div v-for="item in headNav"
           :key="item.active"
           :class="{active:item.active == active}"
           class="nav-item"
           @click="to(item.page)">
        <!--                <img :src="item.icon" alt="">-->
        <i :class="item.iconfont"></i>
        <b>{{ item.name }}</b>
      </div>
    </div>
    <div class="sign-out" @click="sginout">
      <img alt="" src="@/assets/images/yonghuicon.png">
      <p>管理员</p>
      <img alt="" src="@/assets/images/tuichu.png">
    </div>
  </div>
</template>
<script>
export default {
  name: "headP",
  data() {
    return {
      headNav: [
        {
          name: '首页',
          icon: require('@/assets/images/shouye.png'),
          iconfont: 'iconfont icon-shouye-copy',
          active: 1,
          page: '/admin/index'
        },
        {
          name: '机构管理',
          icon: require('@/assets/images/jigouxinxi.png'),
          iconfont: 'iconfont icon-gongsi',
          active: 2,
          page: '/admin/orgList'
        },
        {
          name: '星级评定管理',
          icon: require('@/assets/images/xingjipingding.png'),
          iconfont: 'iconfont icon-xingxing',
          active: 3,
          page: '/admin/evaluateList'
        },
        {
          name: '预警管理',
          icon: require('@/assets/images/fengxianyujing.png'),
          iconfont: 'iconfont icon-yujing',
          active: 4,
          page: '/admin/riskList'
        },
        {
          name: '信息公示管理',
          icon: require('@/assets/images/xuanchuanhuodong.png'),
          iconfont: 'iconfont icon-xuanchuanhuodong-copy',
          active: 5,
          page: '/admin/policiesAndRegulationList'
        },
        {
          name: '权限管理',
          icon: require('@/assets/images/xiazaizhongxin.png'),
          iconfont: 'iconfont icon-quanxianshezhi',
          active: 6,
          page: '/admin/account'
        }
      ]
    }
  },
  props: {
    active: {
      type: [String, Number],
      default: 1
    },
  },
  computed: {
    // user() {
    //   return this.$store.state.user
    // },
  },
  components: {},
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.$store.state.user.pid) {
        let findIndex = this.headNav.findIndex(item => {
          return item.active == 6
        })
        let _item = this.headNav[findIndex]
        _item.page = '/admin/log'
        this.headNav.splice(findIndex, 1, _item)
      }
    },
    // 跳转
    to(path) {
      this.$router.replace(path)
    },
    sginout() {
      this.$confirm(
        '您确定要退出吗？',
        '温馨提示', {
          confirmButtonText: '确定',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/login')
        })
      })
    }
  },
  watch: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.head-flex {
  width: 100%;
  height: 173px;
  background: url("../../../assets/images/headerbgc.png");
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sign-out {
    padding: 0 15px;
    height: 41px;
    background-color: rgba(255, 255, 255, .22);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    padding-right: 8px;
    margin-right: 20px;
    cursor: pointer;

    p {
      flex: 1;
      padding: 0 5px;
      font-size: 18px;
      color: #ffffff;
      padding-right: 10px;
    }
  }

  .head-nav {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;

    .nav-item {
      width: max-content;
      height: 40px;
      margin-left: 2px;
      border-radius: 6px;
      padding-left: 5px;
      padding-right: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        font-size: 21px;
        color: #ffffff;
        margin-right: 5px;
        margin-left: 2px;
      }

      b {
        font-size: 18px;
        color: #ffffff;
        font-weight: normal;
      }

      &.active {
        background-color: rgba(255, 255, 255, .22);

        b {
          font-weight: bold;
        }
      }
    }
  }

  .logo {
    img {
      width: 760px;
      margin: 0 38px;
    }
  }
}
</style>


